import { postAPI } from 'framework/api/http';
import { useMutation } from 'react-query';

interface UpdateVideoMonStatusInterface {
  vid: string;
  status: string;
}

export const useUpdateVideoMonetizeStatus = () => {
  const mutate = useMutation(({ vid, status }: UpdateVideoMonStatusInterface) => {
    return postAPI('/external-api/update_video_monetization_status', {
      vid,
      monetization_status: status,
    });
  });

  return mutate;
};

export default useUpdateVideoMonetizeStatus;
